import { useRestoreTasks as _useRestoreTasks } from '@griply/hooks';
import { ActionEvents } from '@griply/types';
import { taskTypeToTrackingTaskType } from '@griply/utils';
import { useCallback } from 'react';
import { useUpdateGoalMutation } from 'shared/hooks/queries/use-update-goal-mutation';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { Task } from 'shared/types/task';

export const useRestoreTasks = () => {
  const track = useTrackEvents();
  const { mutate: updateTasks } = useUpdateTasksMutation();
  const { mutate: updateGoal } = useUpdateGoalMutation();

  const onTaskRestored = useCallback(
    (task: Task) => {
      track(ActionEvents.TaskRestore, {
        type: taskTypeToTrackingTaskType[task.type],
      });
    },
    [track],
  );

  return _useRestoreTasks({ updateTasks, updateGoal, onTaskRestored });
};
